(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/account-selector-react/assets/react/action-types.js') >= 0) return;  svs.modules.push('/components/numbergames/account-selector-react/assets/react/action-types.js');

'use strict';

svs.numbergames.accountSelectorReact.actionTypes = {
  FETCH_ACCOUNT_LIST: 'FETCH_ACCOUNT_LIST',
  SET_ACCOUNT_LIST: 'SET_ACCOUNT_LIST',
  SET_ACCOUNT: 'SET_ACCOUNT',
  INIT: 'INIT'
};

 })(window);